import React, { useEffect, useState } from "react";
import {
  AspectRatio,
  Box,
  Alert,
  AlertIcon,
  AlertDescription,
  Spinner,
  Center,
  Stack,
} from "@chakra-ui/react";
import LiveAlert from "./LiveAlert";
import { Feed, getFeed } from "../data/api";
import LiveFeed from "./LiveFeed/LiveFeed";
import moment from "moment";
import useAuth from "../hooks/useAuth";

const FeedTab = () => {
  const [liveFeed, setLiveFeed] = useState<Feed[]>();
  const [updateCountdown, setUpdateCountdown] = useState(120);
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      getFeed(token).then(setLiveFeed);
      const interval = setInterval(() => {
        getFeed(token).then(setLiveFeed);
        setUpdateCountdown(120);
      }, 120000);
      const countdownInterval = setInterval(() => {
        setUpdateCountdown((prev) => Math.max(prev - 1, 0));
      }, 1000);
      return () => {
        clearInterval(interval);
        clearInterval(countdownInterval);
      };
    }
  }, [token]);

  return (
    <Box>
      {liveFeed === undefined ? (
        <Center p={10}>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.800"
            size="xl"
          />
        </Center>
      ) : liveFeed.length > 0 ? (
        <>
          <LiveAlert countdown={updateCountdown} />
          <Stack gap={5} my={3}>
            {liveFeed
              .sort((a, b) =>
                moment(a.updatedAt) > moment(b.updatedAt) ? -1 : 1
              )
              .map((feed, i) => (
                <LiveFeed feed={feed} key={i} />
              ))}
          </Stack>
        </>
      ) : (
        <Alert status="warning" textAlign="left">
          <AlertIcon />
          <AlertDescription>
            The feed isn't available right now, has Roses started?
          </AlertDescription>
        </Alert>
      )}
    </Box>
  );
};

export default FeedTab;
